// extracted by mini-css-extract-plugin
export var wrapper = "navigation-module--wrapper--Ungl6";
export var headerWrapper = "navigation-module--header-wrapper--Q95D0";
export var headerContent = "navigation-module--header-content--h-XpW";
export var headerTitle = "navigation-module--header-title--iARPv";
export var headerDescription = "navigation-module--header-description--Fn94b";